module.exports = __webpack_public_path__ + "img/shutterstock_1332814550.af4aa04e.jpg";